import { useMemo } from "react"
import useSubdivisions from "./useSubdivisions"

const useSubdivisionName = (countryCode?: string, subdivisionCode?: string) => {
  const { data: subdivisionQueryData, loading: subdivisionQueryLoading } =
    useSubdivisions(countryCode)

  const subdivisionName = useMemo(() => {
    if (subdivisionCode && !subdivisionQueryLoading && subdivisionQueryData?.country) {
      const { subdivisions } = subdivisionQueryData.country
      const selectedSubdivision = subdivisions.find(s => s.code === subdivisionCode)
      if (selectedSubdivision) return selectedSubdivision.name
    }
    return undefined
  }, [subdivisionQueryData, subdivisionQueryLoading, subdivisionCode])

  return subdivisionName
}

export default useSubdivisionName
